import React from 'react';

export const MenuTitle = (item, shouldSetIcon, icon, iconColor, isNavBar, isActive) => {
    return (
        <div key={item.title} style={{borderBottom: !isNavBar ? '1px solid var(--dms-color-border-strong)' : ''}}>
            <span className={'display-center body-large-roman pt-1 pb-1'} >
                <div style={{ color: `${isNavBar ? 'white' : ''}`}} >
                    {item.icon && <i className={item.icon} />}
                    <div className="display-center" style={{ gap: '6px' }}>
                        <div style={isActive ? { borderBottom: "2px solid #FFFFFF" } : {}}>
                            {item.title}
                        </div>
                        {shouldSetIcon && <i className={icon} style={isNavBar ? { color: iconColor } : { color: iconColor, fontSize: "25px", paddingLeft: "36px"}}></i>}
                    </div>
                </div>
            </span>
        </div>
    );
};
